"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const image_svg_component_1 = require("./image-svg-component");
const map_pin_svg_component_1 = require("./map-pin-svg-component");
class MapSvgComponent {
    constructor(map, snapCtx, position, dimensions) {
        this.map = map;
        this.snapCtx = snapCtx;
        this.position = position;
        this.dimensions = dimensions;
        this.xScale = this.dimensions.width / this.map.coordinateSpace.width;
        this.yScale = this.dimensions.height / this.map.coordinateSpace.height;
    }
    draw() {
        return new Promise((resolve, reject) => {
            const mapImage = new image_svg_component_1.ImageSvgComponent(this.map.imageSource, this.snapCtx, this.position, this.dimensions);
            mapImage.draw().then(() => {
                this.drawMapPins(this.map.pins);
            });
            resolve();
        });
    }
    drawMapPins(mapPins) {
        for (const pin of mapPins) {
            const scaledPinPositon = this.getScaledPosition(pin.position);
            const scaledDimensions = this.getScaledDimensions(pin.dimensions);
            const mapPin = new map_pin_svg_component_1.MapPinSvgComponent(pin, this.snapCtx, scaledPinPositon, scaledDimensions);
            mapPin.draw();
        }
    }
    getScaledPosition(position) {
        const scaledX = position.x * this.xScale;
        const scaledY = position.y * this.yScale;
        return { x: scaledX, y: scaledY };
    }
    getScaledDimensions(dimensions) {
        const scaledWidth = dimensions.width * this.xScale;
        const scaledHeight = dimensions.height * this.yScale;
        return { width: scaledWidth, height: scaledHeight };
    }
}
exports.MapSvgComponent = MapSvgComponent;
